import { FactorForm } from 'core/types';
import { ReactNode } from 'react';

export const factorFormLabels: Record<FactorForm, ReactNode> = {
  COEFFICIENT: 'Coefficient',
  PERCENTAGE: 'Percentage',
};
